import { render, staticRenderFns } from "./RB_zone_master.vue?vue&type=template&id=2dc4dcee&scoped=true"
import script from "./RB_zone_master.vue?vue&type=script&lang=js"
export * from "./RB_zone_master.vue?vue&type=script&lang=js"
import style0 from "./RB_zone_master.vue?vue&type=style&index=0&id=2dc4dcee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc4dcee",
  null
  
)

export default component.exports